module.exports = __webpack_public_path__ + "img/bg-22.f9ebe07a.png";